import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2, ChevronDown } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostCovertNarcissistPT() {
  const articleData = {
    title: 'Seu ex é um narcisista encoberto? (Os textos não mentem)',
    description: 'Quer saber se seu ex é um narcisista encoberto? Descubra 7 comportamentos manipuladores sutis que nossa IA detecta instantaneamente em mensagens de texto.',
    slug: 'is-your-ex-a-covert-narcissist',
    publishDate: '2025-03-08',
    author: 'Editorial Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'O que é um narcisista encoberto e como ele difere dos narcisistas abertos?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Narcisistas encobertos escondem seus comportamentos manipuladores por trás de charme, táticas emocionais sutis e mensagens passivo-agressivas, ao contrário dos narcisistas óbvios e abertos.'
      }
    }, {
      '@type': 'Question',
      name: 'A IA pode detectar narcisismo encoberto em mensagens de texto?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Sim. O Toxic Detector analisa o tom, a culpa, os ciclos de love-bombing, a inconsistência e os padrões de manipulação emocional para sinalizar o comportamento narcisista encoberto.'
      }
    }, {
      '@type': 'Question',
      name: 'Quais são os comportamentos comuns de narcisistas encobertos em textos?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Manipulação emocional, gaslighting, comentários passivo-agressivos, fazer-se de vítima, love-bombing seguido de afastamento e controle sutil.'
      }
    }, {
      '@type': 'Question',
      name: 'Como posso me proteger de um narcisista encoberto?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Documente mensagens, confie em seus instintos, mantenha limites e use ferramentas como o Toxic Detector para identificar padrões manipuladores objetivamente.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://toxicdetector.com/images/logo.png',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/pt/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Link copiado para a área de transferência!');
    }
  };
  return <>
      <MetaTags title="Seu ex é um narcisista encoberto? Como a IA detecta manipulação | ToxicDetector" description="Quer saber se seu ex é um narcisista encoberto? Descubra 7 comportamentos manipuladores sutis que nossa IA detecta instantaneamente." keywords="sinais narcisista encoberto, comportamento narcisista oculto, manipulação narcisista textos, detector narcisista IA" canonical={`https://toxicdetector.com/pt/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/eYBGg4SniMpbkGoP3a2Uyt/file_00000000bb6072439a9d5e3820051ce3.png" schema={[faqSchema, articleSchema]} data-id="element-8782" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-8783">
        <header className="bg-white/90 border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm" data-id="element-8784">
          <div className="max-w-3xl mx-auto px-6 py-4" data-id="element-8785">
            <div className="flex items-center justify-between" data-id="element-8786">
              <Link to="/" className="text-2xl font-bold tracking-tight text-gray-900" data-id="element-8787">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-50 rounded-lg transition-colors" aria-label="Compartilhar artigo" data-id="element-8788">
                <Share2 size={20} className="text-gray-600" data-id="element-8789" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-3xl mx-auto w-full px-6 py-12" data-id="element-8790">
          <Link to="/blog" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors group" data-id="element-8791">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-8792" />
            Voltar ao Blog
          </Link>

          <header className="mb-12" data-id="element-8793">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight text-gray-900" data-id="element-8794">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-8795">
              <time dateTime={articleData.publishDate} data-id="element-8796">
                {new Date(articleData.publishDate).toLocaleDateString('pt-BR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-8797">•</span>
              <span data-id="element-8798">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-8799">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eAKNBAYBhED67QeywsaDY6/1763120946474.jpg" alt="Mulher analisando mensagens de texto em busca de sinais de manipulação narcisista encoberta com IA" className="w-full rounded-2xl shadow-sm border border-gray-200" data-id="element-8800" />
          </div>

          <div className="bg-white rounded-xl p-6 border border-gray-200 mb-12" data-id="element-8801">
            <h2 className="font-bold text-lg mb-4 text-gray-900" data-id="element-8802">Índice</h2>
            <ul className="space-y-3 text-sm" data-id="element-8803">
              <li data-id="element-8804">
                <a href="#emotional-manipulation" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8805">
                  <span className="text-gray-400" data-id="element-8806">→</span> 1. Manipulação
                  emocional em cada mensagem
                </a>
              </li>
              <li data-id="element-8807">
                <a href="#gaslighting" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8808">
                  <span className="text-gray-400" data-id="element-8809">→</span> 2. Gaslighting que se
                  constrói lentamente
                </a>
              </li>
              <li data-id="element-8810">
                <a href="#passive-aggressive" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8811">
                  <span className="text-gray-400" data-id="element-8812">→</span> 3. Comentários
                  passivo-agressivos
                </a>
              </li>
              <li data-id="element-8813">
                <a href="#playing-victim" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8814">
                  <span className="text-gray-400" data-id="element-8815">→</span> 4. Fazer-se de vítima
                  constantemente
                </a>
              </li>
              <li data-id="element-8816">
                <a href="#love-bombing" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8817">
                  <span className="text-gray-400" data-id="element-8818">→</span> 5. Love-Bombing e
                  depois afastamento
                </a>
              </li>
              <li data-id="element-8819">
                <a href="#hidden-control" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8820">
                  <span className="text-gray-400" data-id="element-8821">→</span> 6. Controle oculto e
                  monitoramento
                </a>
              </li>
              <li data-id="element-8822">
                <a href="#inconsistent-tone" className="text-gray-600 hover:text-gray-900 transition-colors flex items-center gap-2" data-id="element-8823">
                  <span className="text-gray-400" data-id="element-8824">→</span> 7. Tom inconsistente
                  entre canais
                </a>
              </li>
            </ul>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-8825">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-8826">
              Já sentiu que seu ex estava manipulando você nos bastidores,
              enquanto parecia encantador e atencioso? Esses são{' '}
              <strong data-id="element-8827">sinais clássicos de um narcisista encoberto</strong>. Ao
              contrário dos narcisistas óbvios, os encobertos escondem sua
              manipulação por trás de táticas emocionais sutis.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-8828">
              Nossa <strong data-id="element-8829">IA detecta manipulação oculta</strong>{' '}
              instantaneamente apenas analisando seus textos. Veja como.
            </p>

            <section id="emotional-manipulation" className="mb-12" data-id="element-8830">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8831">
                1️⃣ Manipulação emocional em cada mensagem
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8832">
                Narcisistas encobertos distorcem emoções para conseguir o que
                querem.
              </p>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8833">
                <p className="italic text-gray-700 text-lg" data-id="element-8834">
                  "Não acredito que você está chateada com isso..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8835">
                A IA detecta culpa sutil e pressão emocional oculta em mensagens
                cotidianas.
              </p>
            </section>

            <section id="gaslighting" className="mb-12" data-id="element-8836">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8837">
                2️⃣ Gaslighting que se constrói lentamente
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8838">
                <p className="italic text-gray-700 text-lg" data-id="element-8839">
                  "Você está lembrando errado..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8840">
                Narcisistas encobertos fazem você duvidar de sua própria
                memória. A IA sinaliza instâncias repetidas onde a realidade
                está sendo distorcida.
              </p>
            </section>

            <section id="passive-aggressive" className="mb-12" data-id="element-8841">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8842">
                3️⃣ Comentários passivo-agressivos
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8843">
                <p className="italic text-gray-700 text-lg" data-id="element-8844">
                  "Claro, o que te fizer feliz..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8845">
                A agressividade passiva é uma marca registrada do narcisismo
                encoberto. A IA reconhece sarcasmo, indiretas e hostilidade
                mascarada.
              </p>
            </section>

            <section id="playing-victim" className="mb-12" data-id="element-8846">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8847">
                4️⃣ Fazer-se de vítima constantemente
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8848">
                <p className="italic text-gray-700 text-lg" data-id="element-8849">
                  "Depois de tudo que eu fiz por você..."
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8850">
                Narcisistas encobertos frequentemente invertem a culpa,
                fazendo-se de vítimas. A IA detecta frases projetadas para
                culpar você.
              </p>
            </section>

            <section id="love-bombing" className="mb-12" data-id="element-8851">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8852">
                5️⃣ Love-Bombing e depois afastamento
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8853">
                <p className="italic text-gray-700 text-lg" data-id="element-8854">
                  "Você é a única pessoa que eu já amei 😢" → ghosting
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8855">
                Este ciclo clássico de afeto intenso seguido de distância
                emocional é um sinal de alerta. A IA identifica esses padrões em
                vários chats.
              </p>
            </section>

            <section id="hidden-control" className="mb-12" data-id="element-8856">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8857">
                6️⃣ Controle oculto e monitoramento
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8858">
                <p className="italic text-gray-700 text-lg" data-id="element-8859">
                  "Só checando... de novo"
                </p>
              </div>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8860">
                Controle sutil disfarçado de cuidado é uma tática encoberta. A
                IA sinaliza comportamento de verificação repetido sem agressão
                aberta.
              </p>
            </section>

            <section id="inconsistent-tone" className="mb-12" data-id="element-8861">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8862">
                7️⃣ Tom inconsistente entre canais
              </h2>
              <div className="bg-gray-50 border-l-4 border-purple-600 p-6 mb-6 rounded-r-xl" data-id="element-8863">
                <p className="italic text-gray-700 text-lg" data-id="element-8864">
                  Chat em grupo: brincalhão / 1:1: crítico
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-8865">
                Narcisistas encobertos frequentemente mascaram seu comportamento
                publicamente enquanto manipulam em privado. A IA compara
                conversas para destacar discrepâncias.
              </p>
            </section>

            <section className="mb-12" data-id="element-8866">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8867">
                🛡 Como se proteger
              </h2>
              <div className="bg-white rounded-xl border border-gray-200 p-6" data-id="element-8868">
                <ul className="space-y-3 text-lg text-gray-600" data-id="element-8869">
                  <li className="flex items-start gap-3" data-id="element-8870">
                    <span className="text-purple-600 font-bold" data-id="element-8871">•</span>
                    <span data-id="element-8872">
                      Confie em seus instintos. Não ignore os sinais de alerta.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-8873">
                    <span className="text-purple-600 font-bold" data-id="element-8874">•</span>
                    <span data-id="element-8875">Guarde capturas de tela para clareza.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-8876">
                    <span className="text-purple-600 font-bold" data-id="element-8877">•</span>
                    <span data-id="element-8878">
                      Compartilhe sua experiência com amigos ou um terapeuta.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-8879">
                    <span className="text-purple-600 font-bold" data-id="element-8880">•</span>
                    <span data-id="element-8881">
                      Use ferramentas como o Toxic Detector para identificar
                      padrões.
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <section className="mb-12" data-id="element-8882">
              <h2 className="text-3xl font-bold mb-6 tracking-tight text-gray-900" data-id="element-8883">
                💀 Veja com seus próprios olhos
              </h2>
              <p className="mb-6 text-lg leading-relaxed text-gray-600" data-id="element-8884">
                O narcisismo encoberto pode ser difícil de detectar, mas a IA
                não perde nada. Envie seus chats e obtenha uma análise
                instantânea:
              </p>
              <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6" data-id="element-8885">
                <p className="text-gray-900 font-bold text-center text-lg" data-id="element-8886">
                  "🚩 78% manipulação detectada. Táticas encobertas
                  identificadas!"
                </p>
              </div>
            </section>

            <section id="faq" className="mb-12" data-id="element-8887">
              <h2 className="text-3xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-8888">
                Perguntas Frequentes
              </h2>
              <div className="space-y-4" data-id="element-8889">
                {faqSchema.mainEntity.map((faq, index) => <details key={index} className="bg-white rounded-xl border border-gray-200 overflow-hidden group" data-id="element-8890">
                    <summary className="px-6 py-4 cursor-pointer font-semibold text-base text-gray-900 hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-8891">
                      <span data-id="element-8892">{faq.name}</span>
                      <ChevronDown size={20} className="text-gray-400 group-open:rotate-180 transition-transform" data-id="element-8893" />
                    </summary>
                    <div className="px-6 pb-4 text-gray-600 leading-relaxed text-sm" data-id="element-8894">
                      {faq.acceptedAnswer.text}
                    </div>
                  </details>)}
              </div>
            </section>
          </div>

          <div className="bg-purple-600 rounded-2xl p-10 text-center text-white mt-16" data-id="element-8895">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-8896">
              💀 Pronto para descobrir a verdade?
            </h2>
            <p className="text-purple-100 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-8897">
              Pare de adivinhar. Envie seus textos para o Toxic Detector e
              obtenha uma pontuação de toxicidade instantânea. Nossa IA revela a
              manipulação encoberta que você pode ter perdido.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-8898">
              <p className="font-bold text-xl" data-id="element-8899">
                "🚩 78% manipulação detectada. Táticas encobertas
                identificadas!"
              </p>
            </div>
            <Link to="/signup" className="inline-block bg-white text-purple-600 px-10 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors" data-id="element-8900">
              Escaneie seus chats agora →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: '7 Sinais de Gaslighting que Nossa IA Detecta Instantaneamente',
          description: 'Aprenda os principais padrões de gaslighting que a IA detecta em suas conversas de texto.',
          slug: '7-signs-of-gaslighting',
          emoji: '💀'
        }, {
          title: 'O Guia Definitivo para Textos Passivo-Agressivos',
          description: 'Detecte comportamento passivo-agressivo e manipulação oculta em mensagens de texto.',
          slug: 'passive-aggressive-texts-guide',
          emoji: '😤'
        }]} data-id="element-8901" />

          <div className="mt-12 text-center" data-id="element-8902">
            <button onClick={handleShare} className="inline-flex items-center text-gray-600 hover:text-gray-900 font-medium transition-colors text-sm" data-id="element-8903">
              <Share2 size={18} className="mr-2" data-id="element-8904" />
              Compartilhar este artigo
            </button>
          </div>
        </article>

        <footer className="bg-white border-t border-gray-200 py-12 mt-16" data-id="element-8905">
          <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-8906">
            <p className="text-gray-500 text-sm" data-id="element-8907">
              © {new Date().getFullYear()} ToxicDetector. Todos os direitos
              reservados.
            </p>
          </div>
        </footer>
      </div>
    </>;
}